import wrapper from 'wrapper';

const backToTopButtonContainer = wrapper.select('.back-to-top-button-container');
let hasButtonShown = false;

// Hack to make back to top button behave sticky in cps (only for shadowdom)
if (wrapper.select('.bbc-news-vj-shadow-dom') && document.getElementById('orb-modules')) {
    document.getElementById('orb-modules').style.overflow = 'visible';
}

backToTopButtonContainer.addEventListener('click', () => {
    wrapper.select('#democrats-candidates-app').scrollIntoView();
    wrapper.selectAll('.facewall-filters-buttons input')[0].focus();
});

wrapper.onRawScroll(() => {
    if (
        (wrapper.selectAll('.filtered').length < 9 &&
            wrapper.select('.header-container__main').getBoundingClientRect().top < 0) ||
        wrapper.select('.facewall-filters-container').getBoundingClientRect().top < 0
    ) {
        if (hasButtonShown) {
            backToTopButtonContainer.classList.remove('hide-button');
            backToTopButtonContainer.removeAttribute('style');
        }
        else {
            hasButtonShown = true;
        }
        backToTopButtonContainer.classList.add('show-button');
    }
    else {
        if (hasButtonShown) {
            backToTopButtonContainer.classList.add('hide-button');
        }
        backToTopButtonContainer.classList.remove('show-button');
    }
});
